/* eslint-disable react/require-default-props */
import { forwardRef } from 'react'
import { Button as NuiButton } from '@theneatcompany/nui'
import type { ButtonProps as NuiButtonProps } from '@theneatcompany/nui'

import { getMessage } from '@/utils/messages'
import type { MessageId, MessageProps } from '@/translations/messages'

type ButtonProps = NuiButtonProps & {
  messageProps?: MessageProps
  messageId?: MessageId
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ messageProps = {}, messageId = messageProps.id, children, ...rest }: ButtonProps, ref) => (
    <NuiButton ref={ref} {...rest}>
      {messageId ? getMessage(messageId, messageProps.values) : children}
    </NuiButton>
  ),
)

Button.displayName = 'Button'

export default Button
